// src/pages/ApiErrorPage.jsx
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';

const ApiErrorPage = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 10 }}>
      <Box>
        <WifiOffIcon sx={{ fontSize: 100, color: 'error.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Unable to Connect
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          We’re having trouble reaching the server. Please check your internet connection or try again later.
        </Typography>
        <Button variant="contained" color="primary" onClick={handleRetry}>
          Retry
        </Button>
      </Box>
    </Container>
  );
};

export default ApiErrorPage;
